// extracted by mini-css-extract-plugin
export default {"commentsContainer":"iDxS3_"};